import { Directive, ElementRef, NgModule, Input, OnInit } from '@angular/core';
import { FILE_NAME } from '../util/constants';
import { LoggerService } from '../services/logger/logger.service';
import { BASE_CONFIG } from '../util/base-settings';
import { UtilFunctions } from '../util/util';

@Directive({
  selector: '[paymentColor]',
})
export class CategoryColorDirective implements OnInit {
  @Input() catStatus: string;

  constructor(private el: ElementRef, private logger: LoggerService, private util: UtilFunctions) {}

  ngOnInit() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('ngOnInit');
      let retColor = this.util.getColor(this.catStatus);
      this.el.nativeElement.style.border = '1px solid ' + retColor[0];
      this.el.nativeElement.style.background=retColor[1];

    } catch (err) {
      let logRequest = this.logger.buildRequest(
        FILE_NAME.CATEGORY_COLOR_DIRECTIVE,
        'error in ngOnInit',
        err.toString(),
        'ngOnInit'
      );
      this.logger.log(logRequest);
    }
  }

  // getColor(pCategoryId) {
  //   let retValue;
  //   try {
  //     if (BASE_CONFIG.IS_DEBUG) console.log('getColor');

  //     switch (pCategoryId) {
  //       case -3:
  //         retValue = ['#468BEB','#468BEB10'];
  //         break;

  //       case -1:
  //         retValue = ['#D12F2C','#D12F2C10'];
  //         break;

  //       case -2:
  //         retValue = ['#E3912D','#E3912D10'];
  //         break;

  //       case -4:
  //         retValue = ['#D97307','#D9730710'];
  //         break;

  //       case -5:
  //         retValue = ['#2BA62F','#2BA62F10'];
  //         break;
  //       case 1:
  //         retValue = ['#054C9D','#054C9D10'];
  //         break;
  //       case 2:
  //         retValue = ['#1496CE','#1496CE10'];

  //         break;
  //       case 3:
  //         retValue = ['#C42F3D','#C42F3D10'];
  //         break;
  //       case 4:
  //         retValue = ['#D0DD37','#D0DD3710'];
  //         break;
  //       case 5:
  //         retValue = ['#EA7C03','#EA7C0310'];
  //         break;
  //       case 6:
  //         retValue = ['#972EC4','#972EC410'];
  //         break;
  //       case 7:
  //         retValue = ['#AB4189','#AB418910'];
  //         break;
  //       case 8:
  //         retValue = ['#FEE5AD','#FEE5AD10'];
  //         break;
  //       case 9:
  //         retValue = ['#24466B','#24466B10'];
  //         break;
  //       case 10:
  //         retValue = ['#EDBF9D','#EDBF9D10'];
  //         break;
  //       case 11:
  //         retValue = ['#149D05','#149D0510'];
  //         break;
  //       case 12:
  //         retValue = ['#EA0B03','#EA0B0310'];
  //         break;
  //       case 13:
  //         retValue = ['#E9C615','#E9C61510'];
  //         break;
  //       case 14:
  //         retValue = ['#B9DC82','#B9DC8210'];
  //         break;
  //       case 15:
  //         retValue = ['#A5548C','#A5548C10'];
  //         break;
  //       case 16:
  //         retValue = ['#D773B3','#D773B310'];
  //         break;
  //       case 17:
  //         retValue = ['#3BA6A0','#3BA6A010'];
  //         break;
  //       case 18:
  //         retValue = ['#A0C663','#A0C66310'];
  //         break;
  //       case 19:
  //         retValue = ['#FFC184','#FFC18410'];
  //         break;
  //       case 20:
  //         retValue = ['#D16C34','#D16C3410'];
  //         break;
  //       case 21:
  //         retValue = ['#FF9A96','#FF9A9610'];
  //         break;
  //       case 22:
  //         retValue = ['#D9EAFA','#D9EAFA10'];
  //         break;
  //       case 23:
  //         retValue = ['#0AF5F1','#0AF5F110'];
  //         break;

  //       ///random color
  //       default:
  //         retValue = ['#ff2ba62f','#ffd12f2c'];

  //         break;
  //     }
  //   } catch (err) {
  //     let logRequest = this.logger.buildRequest(
  //       FILE_NAME.CATEGORY_COLOR_DIRECTIVE,
  //       'error in getColor',
  //       err.toString(),
  //       'getColor'
  //     );
  //     this.logger.log(logRequest);
  //   }
  //   return retValue;
  // }
}

// @NgModule({
//   declarations: [CategoryColorDirective],
//   exports: [CategoryColorDirective],
// })
// export class PaymentColorDirectiveModule {}
